import {Texture} from '@wonderlandengine/api';
import {GameFlowController} from '../../components/game-flow-controller.js';
import {StoreInventoryItems} from '../../enums/StoreInventoryItems.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';
import {MenuPanels} from '../../models/UIModel.js';
import {PowerupStorePopUpParams} from '../panels/shoppe-powerup-popup.js';

export function goToPowerupStorePopup(
    stat: StoreInventoryItems,
    isPerk: boolean,
    icon: Texture
) {
    const gameFlowController = GameFlowController.instance;

    if (gameFlowController.canChangeMenu) {
        PowerupStorePopUpParams.selectedItem = stat;
        PowerupStorePopUpParams.isPerk = isPerk;
        PowerupStorePopUpParams.icon = icon;
        gameFlowController.pushMenu(MenuPanels.StorePowerupsPopup);
    }
}
